// Enums / option lists for the offer-page builder.
//
// Extracted from OfferPageBuilderSimple.js. Plain constants; no dependencies.

/** Element type keys used throughout the offer-page builder. */
export const ELEMENT_TYPES = {
  HEADING: 'heading',
  TEXT: 'text',
  IMAGE: 'image',
  CROPPABLE_IMAGE: 'croppable_image',
  FITTABLE_IMAGE: 'fittable_image',
  BUTTON: 'button',
  VIDEO: 'video',
  VIDEO_WITH_BUTTON_OVERLAY: 'video_with_button_overlay',
  MEDIA: 'media',
  HTML: 'html',
  DIVIDER: 'divider',
  LAYOUT: 'layout',
  CHECKLIST: 'checklist',
  BUTTON_WITH_NOTICE: 'BUTTON_WITH_NOTICE',
  BUTTON_IMAGE_CALLOUT: 'BUTTON_IMAGE_CALLOUT',
  BUTTON_TEXT_VARIANT: 'BUTTON_TEXT_VARIANT',
  BUTTON_HEADLINE_PRODUCT_IMAGE: 'Button + headline + Product Image',
  CUSTOM_LIST: 'CUSTOM_LIST',
  CUSTOM_LIST_TWO_LINE: 'CUSTOM_LIST_TWO_LINE',
  TIMELINE_LIST: 'TIMELINE_LIST',
  PROCESS_STEPS: 'PROCESS_STEPS',
  TEXT_WITH_RIGHT_IMAGE: 'TEXT_WITH_RIGHT_IMAGE',
  LEFT_IMAGE_TEXT: 'LEFT_IMAGE_TEXT',
  QUOTATION_BLOCK: 'QUOTATION_BLOCK',
  CIRCULAR_IMAGE: 'CIRCULAR_IMAGE',
  FAQ_ACCORDION: 'faq_accordion',
  COMPARISON_TABLE: 'comparison_table',
  TWO_COLUMN_COMPARISON: 'two_column_comparison',
  STAR_RATING: 'star_rating',
  STAR_RATING_TABLE: 'star_rating_table',
  IMAGE_OVERLAY: 'image_overlay',
};

/** Layout container types. */
export const LAYOUT_TYPES = {
  SINGLE: 'single',
  SINGLE_ROW_2: 'single-row-2',
  SINGLE_ROW_3: 'single-row-3',
  SINGLE_ROW_4: 'single-row-4',
  SINGLE_ROW_5: 'single-row-5',
  TWO_COLUMN: 'two-column',
  THREE_COLUMN: 'three-column',
  HERO: 'hero',
  FEATURE: 'feature',
  CTA: 'cta',
  INLINE_ROW: 'inline-row'
};

/** Template categories → subtype labels for the template picker UI. */
export const TEMPLATE_TYPE_OPTIONS = {
  'Buttons': [
    'Button w/notice',
    'Button w/Image Call out',
    'Button w/text',
    'Button + headline + Product Image',
    'Call to Action Button',
    'Navigation Button',
    'Hero Button',
    'Submit Button',
    'Download Button'
  ],

  'Lists': [
    'List - Bad things',
    'List - Check boxes',
    'List - Numbered',
    'List - steps/how to'
  ],
  'Icons': [
    'Feature Icons',
    'Features - Guaranteed Service Icons'
    // Add more subtypes as needed
  ],
  'Features': [
    'Features - Header + paragraph + expandable',
    'Features - Media Awards',
    'Ingredients',
    'Product Features',
    'Service Features',
    'Feature Comparison'
  ],
  'Testimonial': [
    'Testimonial - headline + customer images',
    'Testimonial - single'
  ],
  'Comparison': [
    'comparison w competitor'
  ],
  'Highlight block': [
    'pull quote',
    'image + headline + text'
  ],
  'Images': [
    'Image + headline + text + bullets + Button'
  ],
  'Videos': [
    'Video + headline + text + bullets + Button'
  ],
  'Video with button overlay': [
    'Single button overlay',
    'Multiple buttons overlay',
    'Interactive hotspots'
  ],
  'Headline/Subheadline': [
    'Headline w/ highlight bg color, Subheadline',
    'subheadline + paragraph text',
    'Subheadline w/ highlight bg color'
  ],
  'FAQ': [
    'common questions'
  ],
};
